import clsx from 'clsx'
import { useAppSelector } from '../../../lib/redux/hook.ts'
import { colors } from '../../../ui/colors.ts'
import { stageMessages } from './brighty/dto.ts'
import './brighty/messages.css'
import { UserInfoDTO } from './dto.ts'

interface Props {
    message: string
    sent: boolean
    sender?: UserInfoDTO | string
    sameSanderAsPrevious: boolean
    last?: boolean
}

export function MessageBotComponent(props: Props) {
    const { message, sent, sender, sameSanderAsPrevious } = props
    const layoutState = useAppSelector(state => state.layout)
    const brightyState = useAppSelector(state => state.brighty)

    const formatMessage = (text) => {
        return text
            .replace(/\n\n/g, '<br/><br/>')
            .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
            .replace(/\*(.*?)\*/g, '<strong>$1</strong>');
    };

    return (
        <div className='chat-container bubble-transition'
            style={{
                padding: '8px 12px 8px 12px',
                backgroundColor: (sent ? colors.brandPrimary[500] : colors.brandPrimary[100]),
                borderRadius: '12px',
                borderTopRightRadius: (sent ? '0' : '12px'),
                borderTopLeftRadius: (sent ? '12px' : '0'),
                gap: 4,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                width: '100%',
            }}
        >
            {
                !sent &&
                <div className="text-text-xs font-semibold text-brandSecondary-500">
                    {sender as string}
                </div>
            }
            <div
                className=' gap-2 flex justify-between items-end w-full '
            >
                {
                    message === "" ?
                        <div className="flex gap-[2px] mt-2 stage-message">
                            <span style={{
                                opacity: 1,
                                transform: "translateY(0)",
                                transition: "opacity 0.4s ease-in-out, transform 0.4s ease-in-out"
                            }} className={clsx(
                                "inset-0 transition-all duration-500 ease-in-out",
                                " text-text-md leading-6 max-w-full break-words font-normal text-brandPrimary-800", {
                                "text-white": sent
                            })}>{(brightyState.stage.trim() && stageMessages[brightyState.stage]) ? (((brightyState.progress !== 0? (brightyState.progress + '% ' ): '')  + stageMessages[brightyState.stage])) : 'Attendi...'}</span>
                        </div>
                        :
                        <div
                            className={clsx(" text-text-md leading-6 max-w-full break-words font-normal text-brandPrimary-800", {
                                "text-white": sent
                            })}
                            dangerouslySetInnerHTML={{ __html: formatMessage(message) }}
                        />
                }
            </div>
        </div>
    )
}
